export var FLAG_COMING_SOON = 'ComingSoon';
export var FLAG_NEW = 'New';
export var FLAG_NO_LONGER_FOR_SALE = 'NoLongerForSale';
export var FLAG_NOT_SOLD_ONLINE = 'NotSoldOnline';
export var FLAG_OFFER = 'Offer';
export var FLAG_OUT_OF_STOCK = 'OutOfStock';
export var FLAG_SOLD_OUT = 'SoldOut';
export var FLAG_SUPER_DEAL = 'SuperDeal';
export var LABEL_ADD_TO_BASKET_VISIBLE = 'AddToBasketVisible';
export var LABEL_CAN_BE_RESERVED = 'CanBeReserved';
export var LABEL_DEAL = 'Deal';
export var LABEL_PPA = 'PPA';
export var PRODUCT_UNAVAILABLE_FLAGS = [FLAG_COMING_SOON, FLAG_NO_LONGER_FOR_SALE, FLAG_NOT_SOLD_ONLINE, FLAG_OUT_OF_STOCK, FLAG_SOLD_OUT];
//# sourceMappingURL=constants.js.map